import { Highlight as TiptapHighlight } from "@tiptap/extension-highlight";

import HighlightActionButton from "./components/HighlightActionButton";

export const Highlight = TiptapHighlight.extend({
	addOptions() {
		return {
			...this.parent?.(),
			multicolor: true,
			button: ({ editor, t }) => ({
				component: HighlightActionButton,
				componentProps: {
					action: color => {
						if (typeof color === "string") {
							editor.chain().focus().setHighlight({ color }).run();
						}
						if (color === undefined) {
							editor.chain().focus().unsetHighlight().run();
						}
					},
					editor,
					isActive: () => editor.isActive("highlight") || false,
					shortcutKeys: ["⇧", "mod", "H"],
					tooltip: t("editor.highlight.tooltip")
				}
			})
		};
	}
});
